import { useQuery, QueryHookOptions } from '@apollo/client';
import { GET_MY_CARS_V2, GET_MY_CARS_V2_HOME, GET_MY_CARS_V2_LEAN } from './queries';

export type GetMyCarsV2Input = {
  page?: number;
  limit?: number;
  type?: string;
  status?: string;
  locationId?: number;
  q?: string;
};

/** My Listings card row (`HostCarCard`). */
export type GetMyCarsV2ListingsItem = {
  id: string;
  make?: string | null;
  model?: string | null;
  year?: number | null;
  category?: string | null;
  displayName?: string | null;
  thumbnailUrl?: string | null;
  status?: string | null;
  licensePlate?: string | null;
  location?: {
    timezone?: string | null;
    city?: string | null;
  } | null;
  bookings?: Array<{
    id: string;
    startAt?: string | null;
    endAt?: string | null;
  } | null> | null;
};

/** Host home carousel row (`Car` component). */
export type GetMyCarsV2HomeItem = {
  id: string;
  make?: string | null;
  model?: string | null;
  year?: number | null;
  category?: string | null;
  thumbnailUrl?: string | null;
  isCreated?: boolean | null;
  weekdayPrice?: number | null;
  monthlyPrice?: number | null;
  bookings?: Array<{
    id: string;
    startAt?: string | null;
    endAt?: string | null;
  } | null> | null;
};

/** Earnings / swap vehicle picker row. */
export type GetMyCarsV2LeanItem = {
  id: string;
  make?: string | null;
  model?: string | null;
  year?: number | null;
  displayName?: string | null;
  thumbnailUrl?: string | null;
};

/** @deprecated Use GetMyCarsV2ListingsItem | GetMyCarsV2HomeItem | GetMyCarsV2LeanItem */
export type GetMyCarsV2Item = GetMyCarsV2ListingsItem &
  Partial<GetMyCarsV2HomeItem> &
  Partial<GetMyCarsV2LeanItem>;

export type GetMyCarsV2QueryData = {
  getMyCarsV2: {
    totalCount: number;
    hasMore: boolean;
    page: number;
    limit: number;
    totalPages: number;
    items: GetMyCarsV2ListingsItem[];
  };
};

export type GetMyCarsV2HomeQueryData = {
  getMyCarsV2: {
    totalCount: number;
    hasMore: boolean;
    page: number;
    limit: number;
    totalPages: number;
    items: GetMyCarsV2HomeItem[];
  };
};

export type GetMyCarsV2LeanQueryData = {
  getMyCarsV2: {
    totalCount: number;
    hasMore: boolean;
    page: number;
    limit: number;
    totalPages: number;
    items: GetMyCarsV2LeanItem[];
  };
};

export type GetMyCarsV2QueryVars = {
  input: GetMyCarsV2Input;
};

export function useGetMyCarsV2Query(
  options?: QueryHookOptions<GetMyCarsV2QueryData, GetMyCarsV2QueryVars>,
) {
  return useQuery<GetMyCarsV2QueryData, GetMyCarsV2QueryVars>(GET_MY_CARS_V2, options);
}

export function useGetMyCarsV2HomeQuery(
  options?: QueryHookOptions<GetMyCarsV2HomeQueryData, GetMyCarsV2QueryVars>,
) {
  return useQuery<GetMyCarsV2HomeQueryData, GetMyCarsV2QueryVars>(GET_MY_CARS_V2_HOME, options);
}

/** Pickers (earnings / swap) — same shape, no bookings selection. */
export function useGetMyCarsV2LeanQuery(
  options?: QueryHookOptions<GetMyCarsV2LeanQueryData, GetMyCarsV2QueryVars>,
) {
  return useQuery<GetMyCarsV2LeanQueryData, GetMyCarsV2QueryVars>(GET_MY_CARS_V2_LEAN, options);
}
